// See get-video-text.txt for full help
// Import this json from: https://www.googleapis.com/youtube/v3/playlistItems?playlistId=PL9DB69563A161C234&key=KEY-GOES-HERE&fields=items&part=snippet

export const importedVideoData = 

{
    "items": [
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/0FTmI5c9N5qDl2ravFlJdr78myM\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjAyREJBM0MwMUU2QUQ1MjA=",
      "snippet": {
       "publishedAt": "2012-02-14T01:47:12.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "About the Cyclone Testing Station",
       "description": "The Cyclone Testing Station (CTS) is the pre-eminent independent authority on the performance of buildings in severe wind events.\r\n\r\nCTS is located at James Cook Universtiy in Townsville and focuses primarily on the performance of houses and other low rise buildings in Australia and the surrounding region. CTS is actively engaged in research, testing and community education aimed at ensuring that buildings designed to resist severe wind events are safe, economical and sustainable.\r\n\r\nInformation about the Cyclone Testing Station (CTS). Featuring David Henderson [CTS DH 01]",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/F3PV1mc3OuU/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/F3PV1mc3OuU/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/F3PV1mc3OuU/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/F3PV1mc3OuU/sddefault.jpg",
         "width": 640,
         "height": 480
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 0,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "F3PV1mc3OuU"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/leWqblp72uer4BPOBoR1CFNLLy8\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjZEQUNBOEE0NTE1NDc1NjQ=",
      "snippet": {
       "publishedAt": "2012-02-14T01:47:12.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "Building materials designs and site selection",
       "description": "Selecting the most suitable designs and materials for potential events at the given locations. Featuring David Henderson [CTS DH 02]",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/_t4VqUu_3Z4/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/_t4VqUu_3Z4/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/_t4VqUu_3Z4/hqdefault.jpg",
         "width": 480,
         "height": 360
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 1,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "_t4VqUu_3Z4"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/dyAyq4t_lMF2vHCbusPNXwmuexo\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjQzQjJDQkU3M0REQTgxQUY=",
      "snippet": {
       "publishedAt": "2012-02-14T01:47:12.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "Airbox Roof Cladding Test - Cyclic Strength Test",
       "description": "\"At the Cyclone Testing Station, we break everything\". The CTS tests materials to determine how strong they are and this video features airbox testing of materials, replicating high turbulence and high suction pressures from severe wind events. Featuring David Henderson [CTS DH 03-04]\nThis load test was at and then beyond the ultimate limit state for the cladding with washers.   Note the large deformation of the cladding at the screws and the flattening of the washers. It is not representing \"lap lift\" as this puckering is a function of the deformed crests under the screws.  If there is any plastic deformation of the cladding under the screw head (i.e. flattening of the crest) then the roof must be inspected.",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/mOXY7EQpxIw/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/mOXY7EQpxIw/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/mOXY7EQpxIw/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/mOXY7EQpxIw/sddefault.jpg",
         "width": 640,
         "height": 480
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 2,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "mOXY7EQpxIw"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/4d0FXwbPzYIPXIv22hCE0sR4Z8Q\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjIwNDBGREFCMTQ2RjIyQTg=",
      "snippet": {
       "publishedAt": "2017-10-13T01:29:00.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "What happens to fruit in a cyclone?",
       "description": "Have you ever taped up your windows to try and protect yourself in a storm? We went to the Cyclone Testing Station at James Cook University in Townsville and shot a number of items out of a wind cannon at 200km/hr speed to see the effect they would have on a house in a cyclone, and this is what happened. Make sure you’re prepared for this year’s storm season!",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/YuipPwAsCpc/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/YuipPwAsCpc/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/YuipPwAsCpc/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/YuipPwAsCpc/sddefault.jpg",
         "width": 640,
         "height": 480
        },
        "maxres": {
         "url": "https://i.ytimg.com/vi/YuipPwAsCpc/maxresdefault.jpg",
         "width": 1280,
         "height": 720
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 3,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "YuipPwAsCpc"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/kUkkPHVAZIyZnDntfjRbYCsPO3s\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LkNDMjhEMzdGMEQ1NTk0MkY=",
      "snippet": {
       "publishedAt": "2017-10-13T01:30:07.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "What will these household items do in a cyclone?",
       "description": "Have you got any of these loose items lying around your backyard? We went to the Cyclone Testing Station at James Cook University in Townsville and shot a number of items out of a wind cannon at 200km/hr speed to see the effect they would have on a house, and this is what happened. Make sure you’re prepared for this year’s storm season!",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/J59zFyboRO8/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/J59zFyboRO8/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/J59zFyboRO8/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/J59zFyboRO8/sddefault.jpg",
         "width": 640,
         "height": 480
        },
        "maxres": {
         "url": "https://i.ytimg.com/vi/J59zFyboRO8/maxresdefault.jpg",
         "width": 1280,
         "height": 720
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 4,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "J59zFyboRO8"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/jkb5Nrinmm-5fX6sWkAjk-Vj0RU\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LkYxMkM1RjNDNDIxNUI2OUQ=",
      "snippet": {
       "publishedAt": "2017-10-13T01:31:45.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "What can a window withstand in a cyclone?",
       "description": "Have you ever taped up your windows to try and protect yourself in a storm? We went to the Cyclone Testing Station at James Cook University in Townsville and shot a number of items out of a wind cannon at 200km/hr speed to see the effect they would have on a house in a cyclone, and this is what happened. Make sure you’re prepared for this year’s storm season!",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/QMfkNjkBFVc/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/QMfkNjkBFVc/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/QMfkNjkBFVc/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/QMfkNjkBFVc/sddefault.jpg",
         "width": 640,
         "height": 480
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 5,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "QMfkNjkBFVc"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/Y47kkHTsLGqGR0RanTUpxsLPquE\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjQwREE2N0ZFNzA1NTA0QkY=",
      "snippet": {
       "publishedAt": "2017-10-13T01:31:56.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "What happens to a table in cyclone winds?",
       "description": "Have you ever wondered what would happen if a cyclone came through your backyard? We partnered with Monash University in Melbourne and James Cook University in Townsville to test a number of household objects in a wind tunnel, which produced speeds roughly 1/3 of those produced by a category 4 cyclone, and this is what happened. Make sure you’re prepared for this year’s storm season!",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/0krSL58WSds/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/0krSL58WSds/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/0krSL58WSds/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/0krSL58WSds/sddefault.jpg",
         "width": 640,
         "height": 480
        },
        "maxres": {
         "url": "https://i.ytimg.com/vi/0krSL58WSds/maxresdefault.jpg",
         "width": 1280,
         "height": 720
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 6,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "0krSL58WSds"
       }
      }
     },
     {
      "kind": "youtube#playlistItem",
      "etag": "\"XpPGQXPnxQJhLgs6enD_n8JR4Qk/IWw1w-P740BEkNQFbxTn_zjeReM\"",
      "id": "UEw5REI2OTU2M0ExNjFDMjM0LjI0RDQ3RDg2MDBDQ0NFNDE=",
      "snippet": {
       "publishedAt": "2017-10-13T01:32:01.000Z",
       "channelId": "UClfdpIJUOWNzptV73pvIMRg",
       "title": "What happens to a lawnchair in cyclone winds?",
       "description": "Have you ever wondered what would happen if a cyclone came through your backyard? We partnered with Monash University in Melbourne and James Cook University in Townsville to test a number of household objects in a wind tunnel, which produced speeds roughly 1/3 of those produced by a category 4 cyclone, and this is what happened. Make sure you’re prepared for this year’s storm season!",
       "thumbnails": {
        "default": {
         "url": "https://i.ytimg.com/vi/L3XLcALm7Wg/default.jpg",
         "width": 120,
         "height": 90
        },
        "medium": {
         "url": "https://i.ytimg.com/vi/L3XLcALm7Wg/mqdefault.jpg",
         "width": 320,
         "height": 180
        },
        "high": {
         "url": "https://i.ytimg.com/vi/L3XLcALm7Wg/hqdefault.jpg",
         "width": 480,
         "height": 360
        },
        "standard": {
         "url": "https://i.ytimg.com/vi/L3XLcALm7Wg/sddefault.jpg",
         "width": 640,
         "height": 480
        },
        "maxres": {
         "url": "https://i.ytimg.com/vi/L3XLcALm7Wg/maxresdefault.jpg",
         "width": 1280,
         "height": 720
        }
       },
       "channelTitle": "cyclonesandbuildings",
       "playlistId": "PL9DB69563A161C234",
       "position": 7,
       "resourceId": {
        "kind": "youtube#video",
        "videoId": "L3XLcALm7Wg"
       }
      }
     }
    ]
   }
   